import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, withKeys as _withKeys, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {onClickOutside} from '@vueuse/core';
    import {utcToZonedTime, zonedTimeToUtc} from 'date-fns-tz';
    import {format} from 'date-fns';
    import Calendar from 'primevue/calendar';
    import {computed, ref, watch} from 'vue';
    import {WrongFormattedDateError, stringToDate} from './dateConverter';
    import {isTouchDevice} from './helpers';
    import {setupCalendarTranslations} from './setupCalendarTranslations';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'VJoyCalendar',
  props: {
        modelValue: Date,
        error: {type: Boolean, default: false},
        disabled: {type: Boolean, default: false},
        optionalLabel: String,
        dataTestid: String,
        datePattern: {type: String, required: true},
        datePatternRegex: {type: String, required: true},
        placeholder: {type: String, default: ''},
        minDate: Date,
        maxDate: Date,
        required: {type: Boolean, default: false},
        name: String,
        //  Please refactor this
        v2: {type: Boolean, default: false},
    },
  emits: ['update:modelValue', 'toggled'],
  setup(__props, { emit }) {

const props = __props;

    

    

    setupCalendarTranslations();

    const inputValue = computed(() => {
        if (!props.modelValue) {
            return '';
        }

        // We're using a default input date for touch devices, it requires ISO8601 formatted date as value
        return isTouchDevice()
            ? format(utcToZonedTime(props.modelValue, 'UTC'), 'yyyy-MM-dd')
            : format(utcToZonedTime(props.modelValue, 'UTC'), props.datePattern);
    });

    const calendarValue = computed(() => (props.modelValue && !isNaN(props.modelValue.valueOf()) ? utcToZonedTime(props.modelValue, 'UTC') : ''));

    const calendarOpened = ref(false);
    const calendarOnTop = ref(false);
    const datePickerRef = ref<HTMLElement | null>(null);

    watch(calendarOpened, () => {
        emit('toggled', calendarOpened.value);
    });

    onClickOutside(datePickerRef, () => {
        if (calendarOpened.value) {
            calendarOpened.value = false;
        }
    });

    function handleInputClick() {
        if (!isTouchDevice() && datePickerRef.value) {
            calendarOnTop.value = window.innerHeight - datePickerRef.value.getBoundingClientRect().top < 400;
            calendarOpened.value = true;
        }
    }

    function isCustomEvent(value: any): value is CustomEvent {
        return value.detail !== undefined;
    }

    function handleInputValueChange(event: CustomEvent | string) {
        let stringValue: string;

        if (isCustomEvent(event)) {
            // joy-input
            stringValue = event?.detail?.value || '';
        } else {
            // VJoyInput
            stringValue = event;
        }

        try {
            const dateValue = stringToDate(stringValue, isTouchDevice(), props.datePattern, props.datePatternRegex);

            emit('update:modelValue', dateValue || undefined);
        } catch (error) {
            // Nothing to do if the date is wrongly formatted: the user is probably typing the date
            if (!(error instanceof WrongFormattedDateError)) {
                throw error;
            }
        }
    }

    function handleCalendarValueChange(value?: string | string[] | Date | Date[] | undefined) {
        calendarOpened.value = false;
        if (value instanceof Date) {
            emit('update:modelValue', zonedTimeToUtc(value, 'UTC'));
        } else {
            emit('update:modelValue', value);
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "datePickerRef",
    ref: datePickerRef,
    class: "joy-calendar"
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(__props.v2 ? 'VJoyInput' : 'joy-input'), _mergeProps({
      type: _unref(isTouchDevice)() ? 'date' : 'text',
      name: __props.name || 'calendar',
      placeholder: __props.placeholder,
      "optional-label": __props.optionalLabel,
      invalid: __props.error,
      "data-testid": __props.dataTestid,
      disabled: __props.disabled,
      icon: "calendar",
      onClick: handleInputClick,
      onKeydown: _withKeys(_withModifiers(handleInputClick, ["prevent"]), ["enter"]),
      required: __props.required
    }, {
                ...(__props.v2 ? {'model-value': inputValue.value} : {value: inputValue.value}),
            }, _toHandlers({
                ...(__props.v2 ? {'update:model-value': handleInputValueChange} : {'value-change': handleInputValueChange}),
            })), {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16, ["type", "name", "placeholder", "optional-label", "invalid", "data-testid", "disabled", "onKeydown", "required"])),
    (calendarOpened.value)
      ? (_openBlock(), _createBlock(_unref(Calendar), {
          key: 0,
          disabled: __props.disabled,
          inline: "",
          class: _normalizeClass(["joy-calendar__calendar", {'joy-calendar__calendar--top': calendarOnTop.value}]),
          minDate: __props.minDate,
          maxDate: __props.maxDate,
          modelValue: calendarValue.value,
          "onUpdate:modelValue": handleCalendarValueChange
        }, null, 8, ["disabled", "class", "minDate", "maxDate", "modelValue"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})